import AddCardIcon from '@mui/icons-material/AddCard'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import DoneRoundedIcon from '@mui/icons-material/DoneRounded'
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import PhoneIcon from '@mui/icons-material/Phone'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import SearchIcon from '@mui/icons-material/Search'
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded'
import {
  Box,
  Card,
  CardHeader,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import PN from 'persian-number'
import QueryString from 'qs'
import React, { startTransition, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import LoadingButtonForm from '../../shared/forms/LoadingButtonForm'
import Input from '../../shared/Input'
import { getLoading, getRegisterUserId, receiveAppToken, register } from '../../store/auth'
import { deviceList, getDevice, getDeviceInfo, getDeviceList } from '../../store/devices'

interface FormValues {
  id: string
  simno: string
}
// Define interface and  validationSchema form
const initialValues: FormValues = { id: '', simno: '' }

const validationSchema = Yup.object().shape({
  id: Yup.string().required().label('phone number'),
  simno: Yup.string().max(11).required().label('simno'),
})

const DeviceListScreen: React.FC = () => {
  const deviceInfo = useSelector(getDeviceInfo)

  const { t } = useTranslation()
  const [text, setText] = useState('')
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const devices = useSelector(getDeviceList)

  useEffect(() => {
    setCars(devices)
  }, [devices])
  const [cars, setCars] = useState(devices)

  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const [filter, setFilter] = useState<string>('name')
  const [selectedDevice, setSelectedDevice] = useState('')

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, el: any) => {
    setAnchorEl(event.currentTarget)
    setSelectedDevice(el.id)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  const [progress, setProgress] = React.useState(0)

  useEffect(() => {
    dispatch(deviceList({ id: '', simNo: '' }))
  }, [])
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value)
    startTransition(() => {
      if (event.target.value.trim().length === 0) {
        setCars(devices)
      } else {
        setCars(
          devices.filter((car: any) =>
            car.id.toUpperCase().startsWith(PN.convertPeToEn(event.target.value.toUpperCase())),
          ),
        )
      }
    })
  }

  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box>
          <Box display='flex' justifyContent='center' maxHeight='5vh' sx={{ mt: 2 }}>
            <img alt='Logo' src='images/TinyLogo.png' />
          </Box>
          <Box sx={{ direction: 'ltr' }}>
            <Input
              fullWidth
              onChange={handleChange}
              placeholder={t('screens.cars.new.typeSearch_title_text')}
              startAdornment={
                <InputAdornment position='start'>
                  <SearchIcon />
                </InputAdornment>
              }
              sx={{ background: '#fff' }}
              value={text}
            />
          </Box>
        </Box>
        <Box sx={{ overflow: 'auto' }}>
          {cars.map((el: any, index: number) => (
            <Grid item key={el.id} lg={3} md={4} sm={6} xs={12}>
              <Card sx={{ mb: 1, mt: 1, background: 'linear-gradient(rgb(254 255 255), #aaaaaa)' }}>
                <CardHeader
                  action={
                    <IconButton onClick={(e) => handleClick(e, el)}>
                      <MoreVertIcon />
                    </IconButton>
                  }
                  subheader={el.simNo}
                  title={el.id}
                />
                <Box alignItems='center' display='flex' justifyContent='space-between'>
                  <Box sx={{ p: 1 }}>
                    <Typography>نوع خودرو:{el.properties.modelName}</Typography>
                  </Box>
                  <Box>
                    <Typography
                      component={'span'}
                      display='flex'
                      justifyContent='end'
                      sx={{ p: 1 }}
                    >
                      <Typography>دستگاه شماره</Typography>
                      <Typography
                        component={'span'}
                        sx={{
                          background: 'red',
                          color: 'white',
                          width: '25px',
                          mr: '10px',
                          textAlign: 'center',
                          borderRadius: '7px',
                        }}
                      >
                        {index + 1}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        id='basic-menu'
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        onClose={handleClose}
        open={open}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem
          onClick={() => {
            if (selectedDevice !== undefined) dispatch(getDevice(selectedDevice))
            setTimeout(() => {
              navigate(`/${routes.NEW_CAR}/${selectedDevice}`, {
                state: { location: selectedDevice },
              })
            }, 1100)
          }}
        >
          <ListItemIcon>{<AddCardIcon />}</ListItemIcon>
          <ListItemText>{t('screens.deviceList.updateCar_button_text')}</ListItemText>
        </MenuItem>
      </Menu>
    </Container>
  )
}

export default DeviceListScreen
